import template from './llm-assignment-form.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-llm-connect-llm-assignment-form', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
        showModal: {
            type: Boolean,
            default: true,
        },
        maskedSecret: {
            type: String,
            default: '',
        },
    },

    emits: ['save', 'cancel'],

    data() {
        return {
            isSaving: false,
            prefixOptions: [],
            chainEntries: [],
        };
    },

    computed: {
        isNew() {
            return !this.entity.id;
        },

        modalTitle() {
            return this.isNew
                ? this.$tc('TopdataLlmConnectSW6.assignment.modalTitleAdd')
                : this.$tc('TopdataLlmConnectSW6.assignment.modalTitleEdit');
        },
    },

    created() {
        this.loadProviders();
        this.initChain();
    },

    methods: {
        loadProviders() {
            const providerRepo = this.repositoryFactory.create('tdlc_llm_provider');
            const criteria = new Criteria();
            criteria.addFilter(Criteria.equals('active', true));
            providerRepo.search(criteria).then((result) => {
                this.prefixOptions = result.map((p) => ({
                    value: p.prefix,
                    label: `${p.prefix}`,
                }));
                if (this.chainEntries.length > 0 && this.chainEntries[0].prefix === '') {
                    this.chainEntries[0].prefix = this.prefixOptions[0]?.value || '';
                }
            });
        },

        initChain() {
            let parsed = [];
            try {
                parsed = this.entity.chain ? JSON.parse(this.entity.chain) : [];
            } catch (e) {
                parsed = [];
            }

            this.chainEntries = parsed.length
                ? parsed.map((entry) => this.splitEntry(entry))
                : [{ prefix: '', model: '' }];
        },

        splitEntry(entry) {
            const idx = entry.indexOf('/');
            if (idx === -1) {
                return { prefix: '', model: entry };
            }

            return { prefix: entry.slice(0, idx), model: entry.slice(idx + 1) };
        },

        addRow() {
            this.chainEntries.push({ prefix: this.prefixOptions[0]?.value || '', model: '' });
        },

        removeRow(index) {
            this.chainEntries.splice(index, 1);
        },

        onCancel() {
            this.$emit('cancel');
        },

        async onSave() {
            this.isSaving = true;
            const chain = this.chainEntries
                .filter((e) => e.prefix && e.model)
                .map((e) => `${e.prefix}/${e.model}`);

            this.entity.chain = JSON.stringify(chain);
            this.entity.active = this.entity.active ?? true;

            try {
                await this.repository.save(this.entity);
                this.createNotificationSuccess({
                    message: this.$tc('TopdataLlmConnectSW6.assignment.saveSuccess'),
                });
                this.$emit('save');
            } catch (e) {
                this.createNotificationError({
                    message: this.$tc('TopdataLlmConnectSW6.assignment.saveError'),
                });
            } finally {
                this.isSaving = false;
            }
        },
    },
});